import React from "react";
import SectionTitle from "./SectionTitle";
import SegmentShareChart from "./SegmentShareChart";

export default function ServicesExcellence() {
  return (
    <section className="relative py-24 bg-[#0a1a2f] overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-[#1e6fcf]/25 blur-3xl services-orb-drift" />
      <div className="absolute -bottom-40 -left-24 w-96 h-96 rounded-full bg-blue-500/15 blur-3xl services-orb-drift-reverse" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#1e6fcf]/5 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6">
        <SectionTitle
          light
          align="center"
          eyebrow="Service Portfolio"
          title={
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#aad4fa] to-[#1e6fcf]">
              Segment Share
            </span>
          }
          subtitle="How our engineering services are distributed across structural repair, waterproofing, protective coatings and specialised restoration work."
        />

        <div className="mt-12 rounded-2xl border border-white/10 bg-white/[0.03] p-4 sm:p-6 backdrop-blur-sm">
          <SegmentShareChart />
        </div>
      </div>
    </section>
  );
}
